<!-- 盘点任务单 -->
 <template>
    <div >
        <!-- 按钮组 -->
        <div class="buttons_box">
            <el-button type="primary" size="mini" class="mini_button" :disabled="!((inventoryCountForm.status === '新建' ||inventoryCountForm.status === '' ) && !inventoryCountPlanData.length) " @click="inventoryCountSave">保存</el-button>
            <el-button type="primary" size="mini" class="mini_button" :disabled="!(inventoryCountForm.status === '新建')" @click="inventoryCountIssue">下发</el-button>
            <el-button type="primary" size="mini" class="mini_button" :disabled="!(inventoryCountForm.status === '已下发') " 
            @click="inventoryCountComplete">盘点结果上传</el-button>
            <el-button type="primary" size="mini" class="mini_button" :disabled="!(inventoryCountForm.status === '已实盘')" 
             @click="inventoryCountEnd">完成</el-button>
            <el-button type="primary" size="mini" class="mini_button" @click="inventoryCountExport">导出盘点表</el-button>
            <!-- <el-button type="primary" size="mini" class="mini_button">完成</el-button>
            <el-button type="primary" size="mini" class="mini_button">车辆报备</el-button> -->
        </div>
        <!-- 表头 -->
        <el-form class="demo-form-inline inventoryCountForm" :inline="true" ref="inventoryCountForm" :model="inventoryCountForm" 
        :rules="inventoryCountFormRules" size="mini" label-width="160px">
            <el-divider content-position="left">任务信息</el-divider>
            <el-form-item label="盘点单号" prop="billNo"> 
                <el-input disabled v-model="inventoryCountForm.billNo" suffix-icon="xxxx" ></el-input>
            </el-form-item>
            <el-form-item label="盘点状态" prop="status"> 
                <el-input disabled placeholder="" v-model="inventoryCountForm.status"  suffix-icon="xxxx"></el-input>
            </el-form-item>
            <el-form-item label="单证员" prop="creator"> 
                <el-input disabled v-model="inventoryCountForm.creator"  suffix-icon="xxxx" ></el-input>
            </el-form-item> 
            <el-form-item label="创建日期" prop="createDate"> 
                <el-date-picker disabled v-model="inventoryCountForm.createDate" type="date" value-format="yyyy-MM-dd"  placeholder="" style="width:100%"> </el-date-picker>
            </el-form-item>
            <el-form-item label="仓库" prop="ckName">
                <el-select placeholder="请选择仓库" v-model="inventoryCountForm.ckName" clearable :disabled="!!inventoryCountPlanData.length ">
                    <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="盘点名称" prop="pdName"> 
                <el-input v-model="inventoryCountForm.pdName"  suffix-icon="xxxx" ></el-input>
            </el-form-item> 
           <el-form-item label="盘点类型" prop="pdType"> 
                <el-select placeholder="请选择盘点类型" v-model="inventoryCountForm.pdType" clearable :disabled="!!inventoryCountPlanData.length ">
                    <el-option v-for="item in pdTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                </el-select>
            </el-form-item> 
            <el-form-item label="备注" prop="remark"> 
                <el-input placeholder="请输入备注" v-model="inventoryCountForm.remark" suffix-icon="xxxx" style="width: 550px;"></el-input>
            </el-form-item>
        </el-form>
        <el-divider content-position="left">计划信息</el-divider>
        <div class="buttons_box" style="justify-content: space-between;">
            <div>
                <el-button type="primary" size="mini" class="mini_button" @click="generateInventoryCountPlan"
                :disabled="inventoryCountForm.status === '新建' ? false : true ">生成盘点计划</el-button>
            </div>
        </div>
        <!-- 日盘计划 -->
        <!-- @checkbox-all="inventoryRowsDelCheckbox" @checkbox-change="inventoryRowsDelCheckbox"  :checkbox-config="{labelField: '', highlight: true}" -->
        <vxe-table id="inventoryCountTable"  size="mini" ref="inventoryCountTable"  v-if="inventoryCountForm.pdType === '日盘' && !!inventoryCountPlanData.length"
        :data="inventoryCountPlanData" border stripe
            header-align="center" :column-config="{resizable: true,sortable: true,drag:true}" max-height="350">
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column field="createDate" title="入库日期" width="110" sortable ></vxe-column>
                <vxe-column field="blNo" title="提单号" sortable ></vxe-column>
                <vxe-column field="boxNo" title="箱号"  sortable ></vxe-column>
                <vxe-column field="goodsName" title="货物名称"   sortable ></vxe-column>
                <vxe-column field="spec" title="规格型号" sortable ></vxe-column>
                <vxe-column field="place" title="库区库位" width="130" sortable >
                    <template #default="{ row }">
                        {{row.place}} - {{row.location}}
                    </template>
                </vxe-column>
                <vxe-column field="netWeight" title="入库净重(吨)" width="130" sortable ></vxe-column>
                <vxe-column field="qty1" title="入库件数1" width="130" sortable ></vxe-column>
                <vxe-column field="outNetWeight" title="出库净重(吨)" width="130" sortable ></vxe-column>
                <vxe-column field="outQty1" title="出库件数1" width="130" sortable ></vxe-column>
                <vxe-column field="endNetWeight" title="结存净重(吨)" width="130" sortable ></vxe-column>
                <vxe-column field="endQty1" title="结存件数1" width="130" sortable ></vxe-column>
                <!-- <vxe-column field="qty1Unit" title="件数1单位" width="100" >
                    <template #default="{ row, column }">
                        {{findNameByCode(row.qty1Unit, unitList)}}
                    </template>
                </vxe-column> -->
        </vxe-table>
        <!-- 全盘计划 -->
        <vxe-table id="inventoryCountAllTable"  size="mini" ref="inventoryCountAllTable"  :data="inventoryCountPlanData" border stripe
            v-if="inventoryCountForm.pdType !== '日盘' && inventoryCountPlanData.length"
            header-align="center" :column-config="{resizable: true,sortable: true,drag:true}" max-height="350">
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column field="createDate" title="入库日期" width="110" sortable ></vxe-column>
                <vxe-column field="ownerName" title="货主单位"  sortable ></vxe-column>
                <vxe-column field="cusDeclNo" title="报关单号" sortable ></vxe-column>
                <vxe-column field="blNo" title="提单号" sortable ></vxe-column>
                <vxe-column field="boxNo" title="箱号"  sortable ></vxe-column>
                <vxe-column field="goodsName" title="货物名称"   sortable ></vxe-column>
                <vxe-column field="spec" title="规格型号" sortable ></vxe-column>
                <vxe-column field="place" title="库区库位" width="130" sortable >
                    <template #default="{ row }">
                        {{row.place}} - {{row.location}}
                    </template>
                </vxe-column>
                <vxe-column field="totalQty1" title="件数1" width="130" sortable ></vxe-column>
                <vxe-column field="qty1Unit" title="件数1单位" width="100" >
                    <template #default="{ row, column }">
                        {{findNameByCode(row.qty1Unit, unitList)}}
                    </template>
                </vxe-column>
                <vxe-column field="totalNetWeight" title="净重(吨)" width="130" sortable ></vxe-column>
                <!-- <vxe-column field="qty1Unit" title="件数1单位" width="100" >
                    <template #default="{ row, column }">
                        {{findNameByCode(row.qty1Unit, unitList)}}
                    </template>
                </vxe-column> -->
        </vxe-table>
        <el-divider content-position="left" >库存信息</el-divider>
        <el-form class="demo-form-inline" :inline="true" ref="inventoryCountSeachForm" :model="inventoryCountSeachForm" size="mini" label-width="80px">
            <el-form-item label="货物名称" prop="goodsName"> 
                <el-select class="width_100" filterable :default-first-option="true" remote :remote-method="getGoodsList"
                    placeholder="请选择货物名称" v-model="inventoryCountSeachForm.goodsName" clearable>
                    <el-option v-for="item in goodsList" :key="item.id" :label="item.goodsName" :value="item.goodsName">
                        <span class="margin_right_20">{{ item.goodsName }}</span>
                        <span class="margin_right_20">{{ item.goodsType }}</span> 
                        <span >{{ item.hsCode }}</span> 
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="货主" prop="ownerName"> 
                <el-select  filterable placeholder="请选择货主" v-model="inventoryCountSeachForm.ownerName" clearable>
                    <el-option v-for="item in customerList" :key="item.id" :label="item.companyName" :value="item.companyName"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="提单号" prop="blNo"> 
                <el-input placeholder="请输入提单号" v-model="inventoryCountSeachForm.blNo" clearable ></el-input>
            </el-form-item>
            <el-form-item label="仓库" prop="ckName"> 
                <el-select :disabled="!!inventoryCountForm.billNo" clearable placeholder="请选择仓库" v-model="inventoryCountSeachForm.ckName" @change="changeCkName">
                    <el-option v-for="item in ckNameList" :key="item" :label="item" :value="item" > </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="库区" prop="place"> 
                <el-select class="width_100" @change="placeEnter" v-model="inventoryCountSeachForm.place" placeholder="请选择库区" clearable>
                    <el-option v-for="item in placeList"  :key="item.name" :label="item.name " :value="item.name + '-' + item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="库位" prop="location">
                <el-select class="width_100" filterable v-model="inventoryCountSeachForm.location" placeholder="请选择库位" clearable>
                    <el-option v-for="item in locationList"  :key="item.locationName" :label="item.locationName " :value="item.locationName">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="" prop=""> 
                <el-button type="primary" size="mini" @click="inventoryCountSeach">搜索</el-button>
                <el-button type="primary" size="mini" @click="inventoryCountResultEntry"
                    :disabled="true">盘盈盘亏</el-button>
            </el-form-item>
        </el-form>
        <vxe-table id="inventoryTable" size="mini" ref="inventoryTable" :data="inventoryList" border stripe max-height="300"
            :column-config="{resizable: true,sortable: true}" header-align="center"  @checkbox-all="inventoryRowsCheckbox"
             @checkbox-change="inventoryRowsCheckbox"  :checkbox-config="{labelField: '', highlight: true }">
            <vxe-column type="checkbox" fixed="left" width="50"></vxe-column>
            <vxe-column type="seq" width="50" fixed="left"></vxe-column>
            <vxe-column field="blNo" title="提单号" width="100" fixed="left"></vxe-column>
            <vxe-column field="goodsName" title="货物名称" width="180" fixed="left"></vxe-column>
            <vxe-column field="ownerName" title="货主单位" width="180" fixed="left"></vxe-column>
            <vxe-column field="customer" title="委托单位" width="180"></vxe-column>
            <vxe-column field="goodsType" title="货物分类" width="100"></vxe-column>
            <vxe-column field="isBonded" title="保税类型" width="70"></vxe-column>
            <vxe-column field="spec" title="规格型号" min-width="150"></vxe-column>
            <vxe-column field="hsCode" title="海关编码" width="100"></vxe-column>
            <vxe-column field="invDecNo" title="核注清单号" width="140"></vxe-column>
            <vxe-column field="cusDeclNo" title="报关单号" width="140"></vxe-column>
            <vxe-column field="skuNo" title="商品料号" width="130"></vxe-column>
            <vxe-column field="handbook" title="账册编号" width="110"></vxe-column>
            <vxe-column field="createDate" title="入库日期" width="100"></vxe-column>
            <vxe-column field="ckName" title="仓库" width="100"></vxe-column>
            <vxe-column field="place" title="库区" width="100"></vxe-column>
            <vxe-column field="location" title="库位" width="100"></vxe-column>
            <vxe-column field="totalNetWeight" title="净重" width="100"></vxe-column>
            <vxe-column field="decUnitName" title="申报单位" width="100"></vxe-column>
            <vxe-column field="totalDecNum" title="申报数量" width="100"></vxe-column>
            <vxe-column field="totalQty1" title="件数1" width="100"></vxe-column>
            <vxe-column field="qty1UnitName" title="件数1单位" width="100"></vxe-column>
            <vxe-column field="totalQty2" title="件数2" width="100"></vxe-column>
            <vxe-column field="qty2UnitName" title="件数2单位" width="100"></vxe-column>
            <vxe-column field="lawUnitFirstName" title="法定第一单位" width="100"></vxe-column>
            <vxe-column field="totalFirstNum" title="法定第一数量" width="100"></vxe-column>
            <vxe-column field="lawUnitSecond" title="法定第二单位" width="100"></vxe-column>
            <vxe-column field="totalSecondNum" title="法定第二数量" width="100"></vxe-column>
            <vxe-column field="note" title="备注" width="100" ></vxe-column>
            <vxe-column field="lotNo" title="LOT号" width="100"  ></vxe-column>
            <vxe-column field="lotKgs" title="LOT重量" width="80" ></vxe-column>
            <vxe-column field="lotOrderNo" title="LOT订单号" width="100" ></vxe-column>
            <vxe-column field="lotMaterialNo" title="LOT物料号" width="100" ></vxe-column>
        </vxe-table>
        <!-- 盘点结果 -->
        <el-divider content-position="left">盘点结果</el-divider>
         <vxe-table id="inventoryCountResult"  size="mini" ref="inventoryCountResult" :data="inventoryCountResultData" border stripe
            header-align="center" :column-config="{resizable: true,sortable: true,drag:true}" max-height="350"  :cell-style="cellStyle"> 
                <vxe-column type="checkbox" fixed="left" width="50"></vxe-column>
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column field="ckName" title="仓库名称" min-width="130" ></vxe-column>
                <vxe-column field="cusDeclNo" title="报关单号" width="150"></vxe-column>
                <vxe-column field="blNo" title="提单号" width="130" ></vxe-column>
                <vxe-column field="boxNo" title="箱号" width="130" ></vxe-column>
                <vxe-column field="goodsName" title="货物名称" width="130" ></vxe-column>
                <vxe-column field="spec" title="规格型号" width="130" ></vxe-column>
                <vxe-column field="place" title="库区库位" width="130" >
                    <template #default="{ row }">
                        {{row.place}} - {{row.location}}
                    </template>
                </vxe-column>
                <vxe-column field="qty1" title="件数1" width="130" >
                    <template #default="{ row }">
                        <span v-if="row.qty1 >=0">+</span> <span v-else>-</span> {{row.qty1}}
                    </template>
                </vxe-column>
                <vxe-column field="qty1Unit" title="件数1单位" width="100" >
                    <template #default="{ row, column }">
                        {{findNameByCode(row.qty1Unit, unitList)}}
                    </template>
                </vxe-column>
                <vxe-column field="netWeight" title="净重(KG)" width="130" >
                    <template #default="{ row }">
                        <span v-if="row.netWeight >=0">+</span> <span v-else>-</span> {{row.netWeight}}
                    </template>
                </vxe-column>
                <vxe-column field="itemNo" title="项号" width="80" ></vxe-column>
                <vxe-column field="invDecNo" title="核注清单号" width="150" ></vxe-column>
                <vxe-column field="ownerName" title="货主单位" width="220" ></vxe-column>
                <vxe-column field="customer" title="委托单位" width="220" ></vxe-column>
                <vxe-column field="createDate" title="入库日期" width="110" ></vxe-column>
        </vxe-table>
        <div class="finish_IMG">
            <div v-for="(item,index) in pdFilesView" :key="index" >
                <el-image class="IMG" :src="item" :preview-src-list="pdFilesView" > </el-image>
            </div>
        </div>
        <div style="width: 100%;height: 200px;"></div>
        <!-- 完成盘点弹窗 -->
          <el-dialog title="盘点完成" width="75%" :visible.sync="inventoryCountCompleteVisible" :before-close="inventoryCountCompleteClose" v-dialogDrag
            :close-on-click-modal="false">
            <!-- 备注 -->
             <el-input v-model="resultNote" placeholder="备注……" type="textarea" :rows="2"></el-input>
            <!-- inventoryCountCompleteTable -->
            <!-- <vxe-table id="inventoryCountCompleteTable"  size="mini" ref="inventoryCountCompleteTable" :data="inventoryCountCompleteTable" border stripe
            :column-config="{resizable: true,sortable: true}"  header-align="center" :row-config="{ isHover: true}" 
            :radio-config="{labelField: '', highlight: true}" style="margin-top: 0px;" min-height="0"  max-height="350">
                <vxe-column type="seq" width="50" fixed="left"></vxe-column>
                <vxe-column field="pdQty1" title="盘点件数" min-width="130" >
                    <template #default="{ row, $rowIndex } ">
                        <el-input v-model="row.pdQty1" size="mini" style="width: 100px;" onkeyup="value=value.match(/\d+\.?\d{0,4}/,'')"
                        @blur="blurQty1(row,$rowIndex)"></el-input>
                    </template>
                </vxe-column>
                <vxe-column field="ckName" title="仓库名称" min-width="130" ></vxe-column>
                <vxe-column field="cusDeclNo" title="报关单号" width="150"></vxe-column>
                <vxe-column field="blNo" title="提单号" width="130" ></vxe-column>
                <vxe-column field="boxNo" title="箱号" width="130" ></vxe-column>
                <vxe-column field="goodsName" title="货物名称" width="130" ></vxe-column>
                <vxe-column field="spec" title="规格型号" width="130" ></vxe-column>
                <vxe-column field="place" title="库区库位" width="130" >
                    <template #default="{ row }">
                        {{row.place}} - {{row.location}}
                    </template>
                </vxe-column>
                <vxe-column field="qty1" title="件数1" width="130" ></vxe-column>
                <vxe-column field="qty1Unit" title="件数1单位" width="100" >
                    <template #default="{ row, column }">
                        {{findNameByCode(row.qty1Unit, unitList)}}
                    </template>
                </vxe-column>
                <vxe-column field="netWeight" title="净重(KG)" width="130" ></vxe-column>
                <vxe-column field="itemNo" title="项号" width="80" ></vxe-column>
                <vxe-column field="invDecNo" title="核注清单号" width="150" ></vxe-column>
                <vxe-column field="ownerName" title="货主单位" width="150" ></vxe-column>
                <vxe-column field="customer" title="委托单位" width="150" ></vxe-column>
                <vxe-column field="createDate" title="入库日期" width="110" ></vxe-column>
            </vxe-table> -->
            <div class="finish_text">上传盘点结果</div>
            <el-upload drag
                :action="inventoryCountCompleteIMGURL" multiple :auto-upload="false" 
                list-type="picture-card" :file-list="inventoryCountCompleteFiles"  :headers="headers"
                :on-change="handleChangeInventoryCountComplete"
                :on-remove="handleRemoveInventoryCountComplete"
                :on-preview="handlePreviewInventoryCountComplete"
                :accept="acceptImageTypes"
                >
                <i class="el-icon-plus"></i>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="inventoryCountCompleteClose">取 消</el-button>
                <el-button size="mini" type="primary" @click="inventoryCountCompleteSave">完成</el-button>
            </span>
        </el-dialog>
        <!-- 预览图片 -->
        <el-dialog :visible.sync="dialogVisiblePreview">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>
<script>
import ExcelJS from 'exceljs';
import userProfile from '@/mixins/userProfile.js'
import basicData from '@/config/basicData.js'
import AEObasicData from '@/config/AEObasicData.js'
import clean from 'lodash-clean';
export default {
    name: 'ownerTransfer',
    mixins: [userProfile],
    components:{

    },
    watch: { 
        // 根据仓库不同切换不同的理货员
        'inventoryCountForm.ckName':{
            handler(newVal, oldVal) {
                if (newVal === '纽约路仓库') {
                    // 根据仓库名称切换理货员
                    this.storekeeperList = basicData.storekeeperList ;
                }else if (newVal === '七星河路仓库'){
                    this.storekeeperList = basicData.storekeeperListOut ;
                }else{
                    this.storekeeperList = []
                }
            },
            immediate: true, // 是否立即执行一次
            deep: false // 是否深度监听
        },
    },
    data() {
        return{
            hasHandledToken:false,
            customerList:[], // 货主列表
            goodsList:[], // 货物名称列表
            ckNameList:[], // 获取仓库列表
            placeList:[], // 库区列表
            locationList:[], // 库位列表
            inventoryList:[], // 库存列表
            storekeeperList:[], // 理货员列表
            unitList:AEObasicData.CUS_UNIT, // 计量单位
            pdTypeList:basicData.pdTypeList,
            inventoryCheckbox:[], // 选中库存信息
            inventoryDelCheckbox:[], // 选中计划要删除信息
            inventoryCountResultData:[], // 盘点结果表
            inventoryCountForm:{
                creator:'', // 创建人
                remark:'',
                billNo:'',
                status:'',
                createDate:'',
                ckName:'',
                pdType:'',
            },
            inventoryCountFormRules:{
                ckName: [
                    { required: true, message: '请选择仓库', trigger: 'change' }
                ],
                pdType:[
                    { required: true, message: '请选择盘点类型', trigger: 'change' }
                ]
            },
            inventoryCountPlanData:[], // 盘点计划列表
            resultNote:'', // 盘点结果上传备注
            inventoryCountSeachForm:{ // 查询库存表单
                goodsName:'',
                ownerName:'',
                blNo:'',
                ckName:'',
                place:'',
                location:'',
            },
            inventoryCountCompleteVisible:false, // 盘点完成弹窗
            inventoryCountCompleteTable:[], // 盘点完成列表
            pdFilesView:[], // 盘点上传图片
            // 确认作业完成时上传受理单、车辆货物、异常等图片
            inventoryCountCompleteIMGURL:'wms/taskOp/upLoadFiles',
            acceptImageTypes: '.jpg,.jpeg,.png,.gif,.bmp,.webp',// 限制上传图片类型
            inventoryCountCompleteFiles:[], // 盘点完成图片上传
            headers:{ // 导入文件token
                'token': localStorage.getItem('token')
            },
            dialogImageUrl:'', // 图片预览url
            dialogVisiblePreview:false, // 图片预览弹窗
        }
    },
    created() {
        window.addEventListener('message', (event) => {
            if (event.source === window) {
                // 当页面消息来自自己时（F5刷新）并且hasHandledToken为false时（证明是第一次执行，保证接口只调用一次）
                if(localStorage.getItem('id') && !this.hasHandledToken){
                    this.getCustomerList()
                    this.getckNameList()
                    // 查询详情
                    this.getWMSOwnerDetail(localStorage.getItem('id'))
                }
                return false
            }
            // 父页面消息
            this.handleMessage(event);
        });
    },
    mounted() {
        // 获取当前日期
         this.inventoryCountForm.createDate = new Date().toISOString().split('T')[0] // 格式化为 "2026-02-03"
         window.addEventListener('beforeunload', this.notifyParentBeforeUnload);
         this.setupMessageListener();
    },
    methods: {
        // 通用查找方法
        findNameByCode(code, list) {
            if (!code) return '';
            const item = list.find(item => item.codeValue === code);
            return item ? item.codeName : code; // 找不到就返回原编码
        },
        // 接收父窗口的消息
        handleMessage(event) {
            if (event.data.type === 'SET_TOKEN' && !this.hasHandledToken) {
                this.hasHandledToken = true;
                localStorage.setItem('token', event.data.token);
                localStorage.setItem('name', event.data.name);
                localStorage.setItem('parentOrigin', event.data.parentOrigin);
                // 向父窗口发送消息
                event.source.postMessage(
                    { type: 'TOKEN_RECEIVED' },
                    event.origin
                );
                Promise.resolve().then(() => {
                    this.getckNameList()
                    if(event.data.id !== ''){
                        localStorage.setItem('id', event.data.id);
                        this.getWMSOwnerDetail(localStorage.getItem('id'))
                    }else{
                        this.inventoryCountForm.creator = event.data.name
                    }
                })
            }
        },
        // 获取货主列表
        getCustomerList(){
            this.$api.getCompanyList(  ).then(res =>{
                this.customerList = res.tableData
            })
        },
        // 获取货物计划列表
        getGoodsList(value){
            this.$api.getInUseListBy({param:value} ).then(res =>{
            // this.$api.wmsgetListBy( 1,100,{param:value} ).then(res =>{
                this.goodsList = res.tableData
            })
        }, 
        // 获取仓库
        getckNameList(){
            this.$api.getCkNamesBy(  ).then(res =>{
               this.ckNameList = res
            })
        },
        // 获取库区列表
        getStore(){
            this.$api.getStore( this.inventoryCountSeachForm.ckName ).then(res =>{
                this.placeList = res
            })
        },
        // 查询库位列表
        getLocation(id){
            this.$api.getLocation( id ).then(res =>{
                this.locationList = res
            })
        },
        // 保存表头
        async inventoryCountSave(){
            // 如果有id则新增，有则修改
            if(this.inventoryCountForm.billNo && this.inventoryCountForm.billNo !== '' ){
                await this.$api.wmsUpdatePdHead( this.inventoryCountForm )
                this.$message.success('保存成功');
            } else{
                // 必填验证
                this.$refs.inventoryCountForm.validate(async (valid) => {
                    if (valid) {
                        const res = await this.$api.wmsAddStockTakHead( this.inventoryCountForm )
                        if (localStorage.getItem('id')) {
                            localStorage.setItem('id', res);
                        }
                        await this.getWMSOwnerDetail(res);
                        // 等待查询详情完成
                        this.$message.success('保存成功');
                    }
                })
            }
        },
        // 查询盘点任务单详情
        getWMSOwnerDetail(id){
            this.$api.wmsGetPdContentById( id ).then(res =>{
                this.inventoryCountForm = res.tak
                // this.inventoryCountPlanColumns =res.otSub.columns
                if(res.tak.pdType === "日盘"){
                    this.inventoryCountPlanData = res.pdDays
                }else{
                    this.inventoryCountPlanData = res.pds
                }
                this.inventoryCountSeachForm.ckName = this.inventoryCountForm.ckName
                // 查库区
                this.changeCkName()
                // 如果是结束状态则查询盘点结果和上传图片
                if(this.inventoryCountForm.status === '已完成'){
                    this.getPdByResultBy(this.inventoryCountForm.id)
                }
                if(this.inventoryCountForm.status === '已完成' || this.inventoryCountForm.status === '已实盘' ){
                    this.getIMG(this.inventoryCountForm.id)
                }
            })
        },
        // 获取上传图片
        getIMG(id){
            this.$api.wmsGetTaskFiles(id).then(res => {
                this.pdFilesView = res.pdFiles.map(item => item.filePath)
            })
        },
        // 查询库存
        inventoryCountSeach(){
            // 检查是否保存表头
            if(this.inventoryCountForm.billNo === '' ){
                this.$message.error('请先保存表头');
                return false
            }
            // 必须有一个查询条件
            if(this.inventoryCountSeachForm.ckName === '' && this.inventoryCountSeachForm.ownerName === '' 
            && this.inventoryCountSeachForm.goodsName === '' && this.inventoryCountSeachForm.place === '' 
            && this.inventoryCountSeachForm.blNo === '' && this.inventoryCountSeachForm.location === '' ){
                this.$message.error('至少有一个查询条件！');
                return false
            }
            this.$refs.inventoryCountSeachForm.validate(async (valid) => {
                if (valid) {
                    this.$api.wmsGetStockList( this.inventoryCountSeachForm ,1000,1).then(res =>{
                        this.inventoryList = res.records
                    })
                }
            })
        },
        // 选择仓库后查询库区
        changeCkName(){
            if( this.inventoryCountSeachForm.ckName){
                this.inventoryCountSeachForm.place = ''
                this.inventoryCountSeachForm.location = ''
                this.getStore()
            }
        },
        // 根据库区查询库位列表
        placeEnter(value){
            if(value === ''){
                this.inventoryCountSeachForm.place = ''
                this.locationList = []
            }else{
                const item  = value.split('-')
                this.inventoryCountSeachForm.place = item[0]
                this.getLocation(item[1])
            }
            this.inventoryCountSeachForm.location = ''
        },
        // 多选库存信息
        inventoryRowsCheckbox(){
            const selectedRecords = this.$refs.inventoryTable.getCheckboxRecords();
            this.inventoryCheckbox = selectedRecords
        },
        // 多选计划信息
        inventoryRowsDelCheckbox(){
            const selectedRecords = this.$refs.inventoryCountTable.getCheckboxRecords();
            this.inventoryDelCheckbox = selectedRecords
        },
        // 盘盈盘亏录入
        inventoryCountResultEntry(){
            
        },
        // 生成盘点计划
        async generateInventoryCountPlan(){
            this.$confirm('确认生成' + this.inventoryCountForm.pdType + '计划吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    // 先等待删除完成
                    if(this.inventoryCountPlanData.length > 0){
                        const ids = this.inventoryCountPlanData.map(item => item.id);
                        await this.$api.wmsDeletePdContent(ids)
                    }
                    // 生成计划
                    await this.$api.wmsCreatePdsBy(this.inventoryCountForm.id)
                    this.$message.success('添加盘点计划成功')
                    // 刷新盘点任务
                    await this.getWMSOwnerDetail(this.inventoryCountForm.id)
                    
                } catch (err) {

                    // 删除/查询/新增任意接口报错都会走到这里
                    this.$message.error('生成盘点计划失败：' + (err.msg || err.message || '接口异常'))
                }
            }).catch(() => {
                // 取消弹窗不做操作
            });
        },
        // 通知父级页面
        notifyParentBeforeUnload(){
            const targetOrigin =  localStorage.getItem('parentOrigin')
            window.opener.postMessage(
                { 
                    type: 'WINDOW_CLOSED',
                    value: true,
                },
                targetOrigin
            );
            // localStorage.clear();
        },
        setupMessageListener() {
            // 监听父页面发送的消息
            window.addEventListener('message', (event) => {
                // 验证消息来源（可选，增加安全性）
                if (event.origin !== window.location.origin) {
                // 如果不是同源消息，可以忽略或处理
                }
                if (event.data.type === 'CLOSE_WINDOW_FROM_PARENT') {
                    window.close();
                }
            });
        },
        // 导出
        async inventoryCountExport(){
            if(this.inventoryCountForm.pdType === '日盘'){
                this.printDailyPlate()
            }else{
                this.printAllPlate()
            }
        },
        // 打印日盘
        async printDailyPlate(){
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            
            const titleRow = worksheet.addRow([this.inventoryCountForm.ckName + '库存日盘点明细表']);
            worksheet.mergeCells('A1:M1');
            titleRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
            titleRow.getCell(1).font = { bold: true, size: 16 };
            titleRow.height = 30;
            // 1. 添加信息行（手动添加，不使用列配置）
            const infoRow1 = worksheet.addRow([
                '盘点人:' + this.inventoryCountForm.creator + '            ' + 
                '盘点时间:' + this.inventoryCountForm.createDate + '            ' + 
                '盘点类型:' + this.inventoryCountForm.pdType
            ]);
            worksheet.mergeCells('A2:M2');
            infoRow1.getCell(1).font = { bold: true, size: 12 };
            infoRow1.height = 20;

            const infoRow2 = worksheet.addRow([
                '备注:' + this.inventoryCountForm.remark
            ]);
            worksheet.mergeCells('A3:M3');
            infoRow2.getCell(1).font = { bold: true, size: 12 };
            infoRow2.height = 20;
            // 3. 手动添加表头行
            const headerRow1 = worksheet.addRow([
                '入库', '', '', '', '', '', '','', 
                '出库', '',
                '结存', '', 
                '',
            ]);
            // 合并一级表头
            worksheet.mergeCells('A4:H4');  // 基础信息
            worksheet.mergeCells('I4:J4');  // 库存位置
            worksheet.mergeCells('K4:L4');  // 数量信息
            headerRow1.getCell(1).font = { size: 12 };
            headerRow1.height = 20;

            const headerRow2 = worksheet.addRow([
                '入库日期', '提单号', '箱号', '货物名称', '规格型号','库区库位', '净重(吨)', '件数1',  // 入库
                '净重(吨)', '件数1',  // 出库
                '净重(吨)', '件数1',  // 结存
            ]);
    
            // 设置表头样式
            [headerRow1, headerRow2].forEach(row => {
                row.eachCell((cell) => {
                    cell.font = { bold: true };
                    cell.alignment = { horizontal: 'center', vertical: 'middle' };
                    cell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        // fgColor: { argb: 'FFD3D3D3' }
                    };
                    cell.border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    };
                });
                row.height = 28;
            });
            worksheet.mergeCells('M4:M5');
            worksheet.getCell('M4').value = '确认信息无误打√\n信息有误备注详细';
            worksheet.getCell('M4').alignment = { 
                horizontal: 'center', 
                vertical: 'middle', 
                wrapText: true 
            };
            var inventoryList = this.inventoryCountPlanData
            
            // ========== 全局边框样式（所有单元格统一边框，空单元格也生效） ==========
            const allBorder = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }
            // 【核心】数据行样式：左对齐 + 垂直居中 + 边框
            const dataRowStyle = {
                alignment: { vertical: 'middle', horizontal: 'left', wrapText: true },
                border: allBorder
            }
            // 4. 添加数据行
            inventoryList.forEach((item) => {
                const rowData = [
                    item.createDate,
                    item.blNo,
                    item.boxNo,
                    item.goodsName,
                    item.spec,
                    item.place + '-' + item.location,
                    item.netWeight,
                    item.qty1,
                    // item.qty1Unit ? this.findNameByCode(item.qty1Unit, this.unitList) : item.qty1UnitName,
                    item.outNetWeight,
                    item.outQty1,

                    item.endNetWeight,
                    item.endQty1,
                ];
        
                const dataRow = worksheet.addRow(rowData);
                dataRow.height = 28
                // 设置数据行的边框
                dataRow.eachCell(cell => cell.style = dataRowStyle)

            });
            // ========== 新增：数据行末尾添加备注行 ==========
            const finalRemarkRow = worksheet.addRow(['备注：若盘点发现仓库当日出现的非上述明细中的货物，详细记录在下方空白处。']);
            const remarkStart = `A${finalRemarkRow._number}`;
            const remarkEnd = `M${finalRemarkRow._number}`;
            // 合并单元格
            worksheet.mergeCells(`${remarkStart}:${remarkEnd}`);
            // 设置文字样式
            const remarkCell = finalRemarkRow.getCell(1);
            remarkCell.font = { bold: true, size: 12 };
            remarkCell.alignment = {
                horizontal: 'left',
                vertical: 'middle',
                wrapText: true
            };
            finalRemarkRow.height = 30;

            // ===== 统一刷全表边框（标题行、信息行、空白单元格全部覆盖）=====
            const totalRows = worksheet.rowCount;
            const totalCols = 13; // A-M 共13列
            for (let r = 4; r <= totalRows; r++) {
                const row = worksheet.getRow(r);
                for (let c = 1; c <= totalCols; c++) {
                    const cell = row.getCell(c);
                    // 空单元格赋值为空文本，强制渲染边框
                    if (cell.value === undefined || cell.value === null) {
                        cell.value = '';
                    }
                    // 没有边框就补上（不覆盖已有特殊样式）
                    if (!cell.border) {
                        cell.border = allBorder;
                    }
                }
            }
            // 5. 设置列宽（在添加完所有行后设置）
            const columnWidths = [11, 18, 25, 26, 35, 16, 9, 9, 9, 9, 9, 9, 10];
            columnWidths.forEach((width, index) => {
                const col = worksheet.getColumn(index + 1);
                col.width = width;
            });


            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${this.getFormattedDateTime()}_日盘点数据.xlsx`;
            link.click();
            window.URL.revokeObjectURL(url);
        },
        // 打印全盘
        async printAllPlate(){
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            
            const titleRow = worksheet.addRow([this.inventoryCountForm.ckName + '库存全盘点明细表']);
            worksheet.mergeCells('A1:J1');
            titleRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
            titleRow.getCell(1).font = { bold: true, size: 16 };
            titleRow.height = 30;
            // 1. 添加信息行（手动添加，不使用列配置）
            const infoRow1 = worksheet.addRow([
                '盘点人:' + this.inventoryCountForm.creator + '            ' + 
                '盘点时间:' + this.inventoryCountForm.createDate + '            ' + 
                '盘点类型:' + this.inventoryCountForm.pdType
            ]);
            worksheet.mergeCells('A2:J2');
            infoRow1.getCell(1).font = { bold: true, size: 12 };
            infoRow1.height = 20;

            const infoRow2 = worksheet.addRow([
                '备注:' + this.inventoryCountForm.remark
            ]);
            worksheet.mergeCells('A3:J3');
            infoRow2.getCell(1).font = { bold: true, size: 12 };
            infoRow2.height = 20;
            
            const headerRow = worksheet.addRow([
                '入库日期','提单号', '报关单号', '箱号' ,'货主单位', '货物名称', '规格型号','库区库位', '件数1', '净重(吨)'
            ]);
            headerRow.getCell(1).font = { size: 12 };
            headerRow.height = 20;
            headerRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };

            var inventoryList = this.inventoryCountPlanData
            
            // ========== 全局边框样式（所有单元格统一边框，空单元格也生效） ==========
            const allBorder = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }
            // 【核心】数据行样式：左对齐 + 垂直居中 + 边框
            const dataRowStyle = {
                alignment: { vertical: 'middle', horizontal: 'left', wrapText: true },
                border: allBorder
            }
            // 4. 添加数据行
            inventoryList.forEach((item) => {
                const rowData = [
                    item.createDate,
                    item.blNo,
                    item.cusDeclNo,
                    item.boxNo,
                    item.ownerName,
                    item.goodsName,
                    item.spec,
                    item.place + '-' + item.location,
                    item.totalQty1 + this.findNameByCode(item.qty1Unit, this.unitList),
                    item.totalNetWeight,
                ];
                const dataRow = worksheet.addRow(rowData);
                dataRow.height = 28
                // 设置数据行的边框
                dataRow.eachCell(cell => cell.style = dataRowStyle)
            });
            // ========== 新增：数据行末尾添加备注行 ==========
            const finalRemarkRow = worksheet.addRow(['备注：若盘点发现仓库当日出现的非上述明细中的货物，详细记录在下方空白处。']);
            const remarkStart = `A${finalRemarkRow._number}`;
            const remarkEnd = `M${finalRemarkRow._number}`;
            // 合并单元格
            worksheet.mergeCells(`${remarkStart}:${remarkEnd}`);
            // 设置文字样式
            const remarkCell = finalRemarkRow.getCell(1);
            remarkCell.font = { bold: true, size: 12 };
            remarkCell.alignment = {
                horizontal: 'left',
                vertical: 'middle',
                wrapText: true
            };
            finalRemarkRow.height = 30;

            // ===== 统一刷全表边框（标题行、信息行、空白单元格全部覆盖）=====
            const totalRows = worksheet.rowCount;
            const totalCols = 10; // A-M 共13列
            for (let r = 4; r <= totalRows; r++) {
                const row = worksheet.getRow(r);
                for (let c = 1; c <= totalCols; c++) {
                    const cell = row.getCell(c);
                    // 空单元格赋值为空文本，强制渲染边框
                    if (cell.value === undefined || cell.value === null) {
                        cell.value = '';
                    }
                    // 没有边框就补上（不覆盖已有特殊样式）
                    if (!cell.border) {
                        cell.border = allBorder;
                    }
                }
            }
            // 5. 设置列宽（在添加完所有行后设置）
            const columnWidths = [11, 20, 25, 25, 20, 25, 35, 10, 10, 10,];
            columnWidths.forEach((width, index) => {
                const col = worksheet.getColumn(index + 1);
                col.width = width;
            });


            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${this.getFormattedDateTime()}_全盘点数据.xlsx`;
            link.click();
            window.URL.revokeObjectURL(url);
        },
        getFormattedDateTime() {
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day}_${hours}:${minutes}:${seconds}库存数据`;
        },
        // 盘点结果上传
        inventoryCountComplete(){
            this.inventoryCountCompleteVisible = true
            // // 选中计划信息中数据录入结果,没选中则证明没问题
            // if(this.inventoryDelCheckbox.length !== 0){
            //     // this.inventoryCountCompleteTable = this.inventoryCountPlanData.map(item => {
            //     this.inventoryCountCompleteTable = this.inventoryDelCheckbox.map(item => {
            //         return {
            //             ...item,
            //             pdQty1: item.pdQty1 ? item.pdQty1 : item.qty1,
            //             pdQty2: item.pdQty2 ? item.pdQty1 : ( item.qty2 ? item.qty2 : ''),
            //             pdNetWeight: item.pdNetWeight ? item.pdNetWeight : item.netWeight,
            //             pdDecNum: item.pdDecNum ? item.pdDecNum : item.decNum ,
            //             pdDecAmount: item.pdDecAmount ? item.pdDecAmount : ( item.decAmount ? item.decAmount : '') ,
            //             pdFirstNum: item.pdFirstNum ? item.pdFirstNum : item.firstNum,
            //             pdSecondNum: item.pdSecondNum ? item.pdSecondNum : (item.secondNum ? item.secondNum : '') ,
            //         }
            //     })
            // }else{
            //     this.inventoryCountCompleteTable = []
            // }
        },
        // 关闭录入弹窗
        inventoryCountCompleteClose(){
            // this.$refs.inventoryCountTable.clearCheckboxRow()
            this.inventoryCountCompleteTable = []
            this.inventoryDelCheckbox = []
            this.resultNote = ''
            this.inventoryCountCompleteVisible = false
            // 查询数据
            this.getWMSOwnerDetail(this.inventoryCountForm.id)
            // this.inventoryCountSeach()
        },
        // 下发盘点
        inventoryCountIssue(){
            // 如果没有计划信息则不允许下发,月盘允许没有计划下发
            if(this.inventoryCountPlanData.length === 0 ){
                this.$message.error('请先生成盘点计划')
                return
            }
            this.$confirm('确定下发盘点任务吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.wmsIssuePdDetails(this.inventoryCountForm.id).then(res =>{
                    this.$message({
                        message: '下发成功',
                        type: 'success'
                    });
                    this.getWMSOwnerDetail(this.inventoryCountForm.id)
                })
            }).catch(() => {
            })
        },
        // 盘点录入的时候x修改件数1，同步修改净重、申报数量、申报金额
        blurQty1(row ,index){
            if(row.pdQty1 !== this.inventoryCountCompleteTable[index].qty1){
               row.pdQty2 = this.calculateAllPlanFields(this.inventoryCountCompleteTable[index].qty2,this.inventoryCountCompleteTable[index].qty1,row.pdQty1)
                row.pdNetWeight = this.calculateAllPlanFields(this.inventoryCountCompleteTable[index].netWeight,this.inventoryCountCompleteTable[index].qty1,row.pdQty1)
                row.pdDecNum = this.calculateAllPlanFields(this.inventoryCountCompleteTable[index].decNum,this.inventoryCountCompleteTable[index].qty1,row.pdQty1)
                row.pdDecAmount = this.calculateAllPlanFields(this.inventoryCountCompleteTable[index].decAmount,this.inventoryCountCompleteTable[index].qty1,row.pdQty1)
                row.pdFirstNum = this.calculateAllPlanFields(this.inventoryCountCompleteTable[index].firstNum,this.inventoryCountCompleteTable[index].qty1,row.pdQty1)
                row.pdSecondNum = this.calculateAllPlanFields(this.inventoryCountCompleteTable[index].secondNum,this.inventoryCountCompleteTable[index].qty1,row.pdQty1)
            }
        },
        // 净重、申报数量、金额、件数2，法一，法二 计算
        calculateAllPlanFields(number,qty1Value,planQty1Value){
            if(!number){
                return null
            }else{
                const value = Number(number) || 0;
                const qty1 = Number(qty1Value); // 选中数据的件数1
                const planQty1 = Number(planQty1Value); // 填写出库的件数1
                // 计算并保留指定位小数
                const result = (value / qty1) * planQty1;
                
                const factor = Math.pow(10, 4);  // 10000
                // Number.EPSILON  大约是 2.220446049250313e-16 这是 JavaScript 中最小的正数用于解决浮点数计算中的精度问题
                return Math.round((result + Number.EPSILON) * factor) / factor;  // 加一个极小的数，避免浮点数误差;乘以10^4，将小数变为整数,四舍五入
            }
        },
        // 录入盘点保存
        inventoryCountCompleteSave(){
            if(this.inventoryCountCompleteFiles.length === 0){
                this.$message({
                    type: "warning",
                    message: '请上传盘点表图片'
                })
                return
            }
            this.$confirm('确定保存吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 确定按钮点击事件
                const id = this.inventoryCountForm.id
                // 上传图片
                const IMGFiles = new FormData();
                this.inventoryCountCompleteFiles.forEach(item => {
                    IMGFiles.append('files', item.raw);
                });
                // var params = clean(this.inventoryCountCompleteTable);
                this.$api.wmsPushPicForTak(id,this.resultNote,IMGFiles).then(async (res)  => {
                    this.$message({
                        type: "success",
                        message: '盘点完成成功'
                    })
                    
                    await this.inventoryCountCompleteClose()
                })
            })
        },
        // 文件上传状态
        handleChangeInventoryCountComplete(file, fileList){
            this.inventoryCountCompleteFiles = fileList
        },
        handleRemoveInventoryCountComplete(file, fileList){
            this.inventoryCountCompleteFiles = fileList
        },
        handlePreviewInventoryCountComplete(file){
            this.dialogImageUrl = file.url;
            this.dialogVisiblePreview = true;
        },
        // 盘点完成
        inventoryCountEnd(){
            this.$confirm('确定完成盘点任务吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async() => {
                try {
                    // 完成盘点任务
                    await this.$api.wmsFinishPd(this.inventoryCountForm.id);
                    this.$message({
                        message: '盘点任务完成',
                        type: 'success'
                    });
                    // 2. 按顺序获取详情
                    await this.getWMSOwnerDetail(this.inventoryCountForm.id);
                    
                } catch (error) {
                    this.$message.error(error.message || '操作失败');
                }
            }).catch(() => {
            })
        },
        // 获取盘点结果
        getPdByResultBy(id) {
            // this.$api.wmsGetPdByResultBy(this.inventoryCountForm.id).then(res =>{
            //     this.inventoryCountResultData = res
            // })
        },
        // 盘点结果显示样式
        cellStyle({ row, column }) {
            // 针对特定列的样式
            const numericFields = ['qty1', 'netWeight'];
            
            if (numericFields.includes(column.field)) {
            const value = row[column.field];
            
            // 检查是否为负数
            if (value !== null && value !== undefined && value < 0) {
                return {
                color: '#f56c6c',  // 红色
                fontWeight: 'bold'
                };
            }
            
            // 正数显示绿色（可选）
            if (value > 0) {
                return {
                color: '#67c23a',  // 绿色
                fontWeight: 'bold'
                };
            }
            }
            
            return {};
        }
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.notifyParentBeforeUnload)
        
    },
}
</script>
<style style lang="less" scoped>
.width_100{
    width:100%;
}
// 按钮
.buttons_box{
    margin: 5px 15px;
    display: flex;
    align-items: center;
}
.mini_button{
    padding: 3px 8px !important;
}
.inventoryCountForm{
    margin: 10px;
}
// 表头样式
.inventoryCountForm .el-col-4{
    padding-left: 8px !important;
    padding-right: 8px !important;
}
.inventoryCountForm .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
    // margin-bottom: 3px !important;
    margin-right: 5px !important;
}
// 分割线颜色
.el-divider__text{
    color: #797c81 !important;
}
.el-divider--horizontal {
    margin: 10px 0;
}
.el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered {
    margin-left: 5px;
}
.mini_button_text{
    padding: 3px 3px !important;

}
// 上传附件
.label_box{
    color: #606266;
    font-size: 14px;
    line-height: 28px;
    display: flex;
    margin: 0px 30px  10px 100px; 
}
.label{
    margin-right: 10px;
}
.finish_text{
    font-size: 14px;
    font-weight: bold;
    margin: 5px 0px;
}
.finish_IMG{
    display: flex;
}
.finish_IMG .IMG{
    width: 150px; 
    height: 150px;
    margin-left: 10px;
}
::v-deep .el-upload--picture-card{
    width:100px !important;
    height:100px !important;
    line-height: 100px !important;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item{
    width:100px !important;
    height:100px !important;
}
::v-deep .el-upload-dragger{
    width:100px !important;
    height:100px !important;
    line-height: 100px !important;
}
</style>